var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cq-page"},[_c('query-config',{key:_vm.routeKey,attrs:{"api":_vm.api,"mark":_vm.mark,"app-id":_vm.appId,"template-id":_vm.templateId,"edit-template-name":_vm.templateName},on:{"execute":_vm.onExecute,"open-history":_vm.goHistory}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0bf7cc2c","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/iview-loader??ref--5!./src/component/data-grid/custom-query/pages/config-page.vue
// module id = 123
// module chunks = 0